import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  VStack,
  useToast,
} from '@chakra-ui/react';
import WhatsappOptOutsApi from '../../../../api/whatsappOptOuts';

const WhatsappOptOutFormModal = ({ isOpen, onClose, onSuccess }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleClose = () => {
    setPhoneNumber('');
    setReason('');
    onClose();
  };

  const handleSubmit = async () => {
    const trimmedPhone = phoneNumber.trim();
    const trimmedReason = reason.trim();

    if (!trimmedPhone) {
      toast({ title: 'נדרש מספר טלפון', status: 'error', duration: 3000, isClosable: true });
      return;
    }
    if (trimmedReason.length < 10) {
      toast({
        title: 'סיבה חייבת להכיל לפחות 10 תווים',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      const res = await WhatsappOptOutsApi.create({
        phoneNumber: trimmedPhone,
        reason: trimmedReason,
      });
      // Backend returns { success: boolean, item: row | null } — a false success means the
      // phone failed server-side validation even though the HTTP call was 2xx.
      if (res?.data?.success === false) {
        toast({
          title: 'השרת דחה את המספר. בדוק את הפורמט ונסה שוב.',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({ title: 'הוסף לרשימת הסרה בהצלחה', status: 'success', duration: 3000, isClosable: true });
      onSuccess();
      handleClose();
    } catch (err) {
      const msg = err?.response?.data?.message || 'שגיאה בהוספה לרשימת הסרה';
      toast({ title: msg, status: 'error', duration: 3000, isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton position="absolute" left="8px" right="auto" top="8px" zIndex="3" />
        <ModalHeader>הוספת מספר לרשימת הסרה</ModalHeader>
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>מספר טלפון</FormLabel>
              <Input
                placeholder="05XXXXXXXX"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>סיבה</FormLabel>
              <Textarea
                placeholder="לדוגמה: לקוחה התקשרה וביקשה להסיר אותה (שם, חברה, תאריך)"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={3}
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose}>
            ביטול
          </Button>
          <Button colorScheme="orange" onClick={handleSubmit} isLoading={loading}>
            הוסף להסרה
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WhatsappOptOutFormModal;
